import { styled } from '@mui/material';

/** The "nothing heard" message rises in under the question, like the design's reply echo. */
export const RiseIn = styled('p')({
  '@keyframes formsDialogRise': {
    from: { opacity: 0, transform: 'translateY(6px)' },
    to: { opacity: 1, transform: 'none' },
  },
  animation: 'formsDialogRise 380ms cubic-bezier(0.32, 0.72, 0, 1) both',
  '@media (prefers-reduced-motion: reduce)': {
    animation: 'none',
  },
});
